import { AnimatePresence, motion } from "framer-motion";
import { MUSKI_IMAGES, MOODS } from "../muskiData";
import ReactionOverlay from "./ReactionOverlay";

export default function MuskiStage({ mood, tagline, reactions, shaking }) {
  const cfg = MOODS[mood];
  return (
    <div
      data-testid="muski-stage"
      className={`glass relative overflow-hidden rounded-3xl p-5 sm:p-7 ${cfg.ring} ${shaking ? "shake" : ""}`}
      style={{ transition: "box-shadow 0.5s ease" }}
    >
      {/* mood badge */}
      <div className="relative z-20 flex items-center justify-between">
        <span
          data-testid="mood-indicator"
          className={`font-mono-ui text-xs uppercase tracking-[0.25em] rounded-full border px-3 py-1.5 ${cfg.badge}`}
        >
          Mood · {cfg.label}
        </span>
        <span className="font-mono-ui text-[11px] uppercase tracking-widest text-slate-400">Ambush Specialist</span>
      </div>

      {/* glowing ambient */}
      <div
        className="pointer-events-none absolute inset-0 z-0"
        style={{ background: `radial-gradient(420px 320px at 50% 60%, ${cfg.glow}, transparent 70%)`, transition: "background 0.5s ease" }}
      />

      {/* portrait */}
      <div className="relative z-10 mt-4 flex items-center justify-center">
        <div className="relative w-full max-w-[420px] aspect-square">
          <AnimatePresence mode="wait">
            <motion.img
              key={mood}
              src={MUSKI_IMAGES[mood]}
              alt={`Muski feeling ${mood}`}
              data-testid="muski-portrait"
              initial={{ opacity: 0, scale: 0.92, filter: "blur(6px)" }}
              animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
              exit={{ opacity: 0, scale: 1.04, filter: "blur(6px)" }}
              transition={{ duration: 0.4, ease: "easeOut" }}
              className={`h-full w-full rounded-2xl object-cover border border-white/10 ${mood === "Ambush" ? "eye-glow" : ""}`}
            />
          </AnimatePresence>
          {mood === "Ambush" && (
            <div className="pointer-events-none absolute inset-0 rounded-2xl ring-2 ring-pink-500/40 animate-pulse" />
          )}
        </div>
        <ReactionOverlay reactions={reactions} />
      </div>

      <p className="relative z-10 mt-4 text-center font-royal italic text-lg sm:text-xl text-slate-200">
        “{tagline}”
      </p>
    </div>
  );
}
